// @ts-nocheck
import common from "@store/Themes/common/styleguide/config/design";
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const design: Styleguide["design"] = {
    ...common,
    typography: {
        ...common?.typography,
        fontFamily: {
            title: `Open Sans, Arial, Helvetica, sans-serif`,
            base: `Open Sans, Arial, Helvetica, sans-serif`,
        },
    },
};

export default design;
